import { currencySymbol } from "../../../ts/Accounts/localisation";
/**
 * Formats a number to a 'prettier' string format.
 * e.g. 1000.23 => £1,000.23
 *
 * @param number | string
 * @param decimals
 * @param tbcOnZero
 */
export function currency(number, decimals = 0, tbcOnZero = null) {
    number = Number(number);
    let isNegative = (number < 0);
    let formattedNumber = Math.abs(number).toFixed(decimals).replace(/./g, function (c, i, a) {
        return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c;
    });
    if (tbcOnZero === true) {
        tbcOnZero = currencySymbol + 'TBC';
    }
    return parseInt(formattedNumber) === 0 && tbcOnZero ? tbcOnZero : (isNegative ? '(' : '') + currencySymbol + formattedNumber + (isNegative ? ')' : '');
}
export default currency;
